var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: _vm.documentType + '-add', params: { lang: _vm.getApiLang(_vm.$language.current) }, query: _vm.query },"rel":"nofollow"}},[_vm._t("default",function(){return [_vm._v("\n    "+_vm._s(_vm._f("uppercaseFirstLetter")(_vm.$documentUtils.getCreationTitle(_vm.documentType)))+"\n  ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }